import React from 'react';

import { RadioButtonLinkGroup } from 'src/components/molecules/RadioButtonGroup/RadioButtonLinkGroup';
import type { UISortOption } from 'src/components/types/UISortOption';
import { DEFAULT_SORT_OPTION_VALUE } from 'src/redux/productsQuery/helpers/getSortOptionValue';

const SORT_NAME = 'sortOptions';
const SORT_ACCESSIBLE_LABEL = 'Sort options';

interface SortOptionsProps {
  sortOptions: UISortOption[];
}

export const SortOptions = ({ sortOptions }: SortOptionsProps) => {
  const hasExplicitSortSelection = sortOptions.some((option) => option.active);

  return (
    <RadioButtonLinkGroup
      accessibleLabel={SORT_ACCESSIBLE_LABEL}
      hideLabel
      name={SORT_NAME}
      radioButtonData={sortOptions.map(({ active, href, title, value }) => ({
        checked: active || (!hasExplicitSortSelection && value === DEFAULT_SORT_OPTION_VALUE),
        href,
        labelText: title,
        value,
      }))}
    />
  );
};
